import { Box, LinearProgress } from "@mui/material";
import { UploadProgress } from "src/types/upload";
import { CustomStyles, getStyles } from "src/styles/theme";
import { formatBytes, formatDuration } from "src/utils/helper";
import defaultStyles, { StylesClasses } from "./styles";

type UploadProgressBarProps = {
  /** Null before the first byte report — the bar then runs indeterminate. */
  progress: UploadProgress | null;
  /** Whether an upload is in flight; nothing renders when it is not. */
  active: boolean;
  label?: string;
  customStyles?: CustomStyles<StylesClasses>;
};

const UploadProgressBar = ({
  progress,
  active,
  label = "Uploading",
  customStyles,
}: UploadProgressBarProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);

  if (!active) return null;

  return (
    <Box {...styles("container")}>
      <LinearProgress
        {...styles("bar")}
        variant={progress ? "determinate" : "indeterminate"}
        value={progress?.percent ?? 0}
      />

      <Box {...styles("stats")}>
        <Box {...styles("transferred")}>
          {progress
            ? `${label} ${progress.percent}% — ${formatBytes(
                progress.loaded
              )} of ${formatBytes(progress.total)}`
            : `${label}…`}
        </Box>

        {!!progress?.bytesPerSecond && (
          <Box {...styles("rate")}>
            {formatBytes(progress.bytesPerSecond)}/s
            {progress.remainingSeconds !== null &&
              ` · ${formatDuration(progress.remainingSeconds)} left`}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default UploadProgressBar;
